import { useState } from "react";
import { Aviso, Botao } from "../ui";

export interface PropsDosCodigosDeRecuperacao {
  codigos: readonly string[];
  /** Texto do botão que segue em frente, depois de a pessoa dizer que guardou. */
  rotuloDoFim?: string;
  aoContinuar: () => void;
}

/**
 * Os códigos de recuperação, mostrados UMA vez.
 *
 * Eles só existem em claro na resposta que os criou — o servidor guarda apenas o hash —, então
 * o aviso fica em destaque ao lado de "Copiar" e "Baixar". A caixa "guardei" que existia aqui foi
 * tirada (08/10/2026): marcar não prova que a pessoa guardou nada, só custava um clique. Cada
 * código vale uma vez e é o que a pessoa usa se perder o celular.
 */
export function CodigosDeRecuperacao({
  codigos,
  rotuloDoFim = "Continuar",
  aoContinuar,
}: PropsDosCodigosDeRecuperacao) {
  const [copiado, setCopiado] = useState(false);

  async function copiar() {
    try {
      await navigator.clipboard.writeText(codigos.join("\n"));
      setCopiado(true);
    } catch {
      setCopiado(false);
    }
  }

  function baixar() {
    const arquivo = new Blob([`Códigos de recuperação do Portal GEOvendas\n\n${codigos.join("\n")}\n`], {
      type: "text/plain",
    });
    const endereco = URL.createObjectURL(arquivo);
    const ancora = document.createElement("a");
    ancora.href = endereco;
    ancora.download = "codigos-de-recuperacao-geovendas.txt";
    ancora.click();
    URL.revokeObjectURL(endereco);
  }

  return (
    <div className="passo-do-mfa" data-testid="codigos-de-recuperacao">
      <Aviso tom="atencao">
        <b>Guarde estes códigos agora.</b> Eles não aparecem de novo. Se você perder o celular, cada
        código entra uma vez no lugar do código do aplicativo.
      </Aviso>
      <ol className="codigos-de-recuperacao" aria-label="Códigos de recuperação">
        {codigos.map((codigo) => (
          <li key={codigo}>{codigo}</li>
        ))}
      </ol>
      <div className="flex flex-wrap gap-2">
        <Botao variante="fantasma" tamanho="pequeno" onClick={() => void copiar()}>
          {copiado ? "Copiados" : "Copiar"}
        </Botao>
        <Botao variante="fantasma" tamanho="pequeno" onClick={baixar}>
          Baixar como arquivo
        </Botao>
      </div>
      <Botao onClick={aoContinuar} variante="verde">
        {rotuloDoFim}
      </Botao>
    </div>
  );
}
